export enum ButtonType {
	submit,
	reset,
	button,
}

export enum ButtonVariant {
	green,
	default,
	secondary,
	error,
	warning,
	inverse,
	inverseGreen,
	inverseRed,
	monochrome,
	impersonate,
	inverseImpersonate,
	black,
	link,
}
